export default function Tickets(){return <div><h1 className="text-2xl font-black">Tickets</h1><textarea className="input mt-4" placeholder="How can we help?"/></div>;}
